<template>
  <sc-card class="page-logs-tracking-event-header-lote">
    <template slot="header">
      <h2 class="has-text-primary is-size-4 card-header-title">Lote</h2>
    </template>

    <template slot="body">
      <p
        class="heading"
        v-if="lote.hash">
        <strong>Nome do lote:</strong>
      </p>

      <span class="hash">{{ lote.hash }}</span>

      <p
        class="heading"
        v-if="getLogisticProvider">
        <strong>Transportadora:</strong>
        <span>{{ getLogisticProvider }}</span>
      </p>

      <p
        class="heading"
        v-if="getOrigin">
        <strong>Origem:</strong>
        <span>{{ getOrigin }}</span>
      </p>

      <sc-button
        theme="primary"
        text="Dado original"
        :loading="loadingPayload"
        @click="openPayload" />

      <sc-button
        theme="warning"
        text="Reprocessar"
        v-if="getSubflow === 'ADD_EVENTS'"
        :loading="loadingReprocess"
        @click="reprocessLote"/>
    </template>
  </sc-card>
</template>

<script>
  import { ScCard, ScTooltip, ScButton, ScFilesGallery } from '@intelipost-js/secure-components';
  import { createNamespacedHelpers } from 'vuex';

  const { mapState, mapActions } = createNamespacedHelpers('analytic/logsTracking');

  export default {
    name: 'sc-logs-tracking-detail-header-lote',
    computed: {
      ...mapState([
        'lote',
        'loadingReprocess',
        'loadingPayload',
      ]),
      getLogisticProvider() {
        const event = this.getFirstEvent();
        return this.getLogisticProviderName(event.logistic_provider_id);
      },
      getOrigin() {
        const event = this.getFirstEvent();
        return event.origin;
      },
      getSubflow() {
        const event = this.getFirstEvent();
        return event.subflow;
      },
    },
    methods: {
      ...mapActions([
        'reprocessLote',
        'getLotePayload',
      ]),
      getFirstEvent() {
        if (!Array.isArray(this.lote.eventsList)) return {};
        const [event = {}] = this.lote.eventsList
          .filter(eventItem => !!eventItem.origin);
        return event;
      },
      getLogisticProviderName(logisticProviderId) {
        return this.$store.getters['logisticProviders/logisticProviderName'](logisticProviderId);
      },
      openPayload() {
        this.getLotePayload()
          .then(fileContent => ScFilesGallery.open(this.$instance, {
            selected: {
              fileName: `${this.lote.hash}.json`,
              fileContent,
              mimeType: 'application/json',
            },
            files: [
              {
                fileName: `${this.lote.hash}.json`,
                fileContent,
                mimeType: 'application/json',
              },
            ],
          }));
      },
    },
    beforeMount() {
      return this.$store.dispatch('logisticProviders/getLogisticProviders');
    },
    components: {
      ScCard,
      ScTooltip,
      ScButton,
    },
  };
</script>

<style lang="scss" scoped>
  .page-logs-tracking-event-header-lote {
    height: 100%;
    .hash {
      word-wrap: break-word;
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/logs/pages/tracking/pages/logs-tracking-lote-detail/components/sc-logs-tracking-lote-detail-header/blocks/sc-logs-tracking-lote-detail-header-lote/ScLogsTrackingLoteDetailHeaderLote.vue?3503fdcd